export default import.meta.ROLLDOWN_FILE_URL_XBpek8I2a_ud6cI3DMNQMA